import React from 'react'
import AdminUserManagement from '@pages/AdminUserManagement'
import { Route, Routes } from 'react-router-dom'
import AdminAuthRouter from './utils/AdminAuthRouter'
import AdminUserDetailManagement from '@pages/AdminUserDetailManagement'
import AdminNoticeManagement from '@pages/AdminNoticeManagement'
import AdminNoticeAdd from '@pages/AdminNoticeAdd'
import AdminNoticeDetailManagement from '@pages/AdminNoticeDetailManagement'
import AdminPostManagement from '@pages/AdminPostManagement'
import AdminPostNoticeAdd from '@pages/AdminPostNoticeAdd'
import AdminPostDetailManagement from '@pages/AdminPostDetailManagement'
import AdminEventManagement from '@pages/AdminEventManagement'

const AdminRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminAuthRouter />}>
        <Route path="/user-management" element={<AdminUserManagement />} />
        <Route
          path="/user-management/:id"
          element={<AdminUserDetailManagement />}
        />
        <Route path="/notice-management" element={<AdminNoticeManagement />} />
        <Route path="/notice-management/add" element={<AdminNoticeAdd />} />
        <Route
          path="/notice-management/:id"
          element={<AdminNoticeDetailManagement />}
        />
        <Route path="/post-management" element={<AdminPostManagement />} />
        <Route path="/post-management/add" element={<AdminPostNoticeAdd />} />
        <Route
          path="/post-management/:id"
          element={<AdminPostDetailManagement />}
        />
        <Route path="/push-management" element={<>푸시관리</>} />
        <Route path="/event-management" element={<AdminEventManagement />} />
      </Route>
    </Routes>
  )
}

export default AdminRouter
